export const MULTI_LOSS_TYPE = 'multi_loss_type'
export const MONTHLY_BILLING = 'monthly_billing'
export const UPSELL = 'upsell'
export const CLAIM_V2 = 'claim_v2'
export const REDIRECT_CLAIM_V2 = 'redirect_claim_v2'
export const DEVICE_RESTRICTIONS = 'device_restrictions'



// WEBPACK FOOTER //
// ./src/constants/feature_flag.js